import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

import Typo from '../Typography/Typo';

type CursorPaginationProps = {
  pageSize: number;
  total: number;
  current: number;
  onChange: (page: number, pageSize?: number) => void;
  disabled?: boolean;
};

const CursorPagination = (props: CursorPaginationProps) => {
  const { pageSize, total, current, onChange } = props;

  const firstPage = 1;
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const prevPage = Math.max(current - 1, firstPage);
  const nextPage = Math.min(current + 1, lastPage);

  return (
    <Style>
      <ul className="pagination">
        <PaginationItem
          className="prev-cursor"
          disabled={props.disabled || current === firstPage}
        >
          <a
            className="pagination-item-link"
            onClick={() =>
              current !== firstPage && !props.disabled && onChange(prevPage)
            }
          >
            <LeftOutlined />
            <Typo type="label2">Prev</Typo>
          </a>
        </PaginationItem>
        <PaginationItem
          className="next-cursor"
          disabled={props.disabled || current === lastPage}
        >
          <a
            className="pagination-item-link"
            onClick={() =>
              current !== lastPage && !props.disabled && onChange(nextPage)
            }
          >
            <Typo type="label2">Next</Typo>
            <RightOutlined />
          </a>
        </PaginationItem>
      </ul>
    </Style>
  );
};

const Style = styled.div`
  .pagination {
    display: flex;
    gap: 9px;
    align-items: center;
    justify-content: center;
    // box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
`;

type PaginationItemStyleProps = {
  disabled?: boolean;
};

const PaginationItem = styled.li<PaginationItemStyleProps>`
  display: inline-block;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  border-radius: 6px;

  a.pagination-item-link {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    gap: 12px;
    width: 100%;
    height: 100%;
    padding: 5px 8px;
    font-size: 12px;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    color: ${(props) =>
      props.disabled ? props.theme.colors.gray400 : props.theme.colors.gray600};
    ${({ disabled }) =>
      !disabled &&
      css`
        &:hover {
          color: ${(props) => props.theme.colors.primary100};
        }
      `}
  }
  transition: all 0.2s;
  background: transparent;
  border: none;
  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        background: ${(props) => props.theme.colors.primaryAlpha(0.08)};
      }
    `}
`;

export default CursorPagination;
